import { render, staticRenderFns } from "./TcoBlocks.vue?vue&type=template&id=7fb82510"
import script from "./TcoBlocks.vue?vue&type=script&lang=js"
export * from "./TcoBlocks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports